import React, { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    >
      <div className="mb-4 text-slate-400 dark:text-slate-500">
        {icon || (
          <div className="w-12 h-12 rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center">
            <Inbox className="w-6 h-6 text-slate-400 dark:text-slate-500" />
          </div>
        )}
      </div>

      <h3 className="text-slate-900 dark:text-white font-bold text-lg mb-2">{title}</h3>

      {description && (
        <p className="text-slate-600 dark:text-slate-400 max-w-md text-sm mb-6 leading-relaxed">
          {description}
        </p>
      )}

      {action && <div className="mt-2">{action}</div>}
    </div>
  );
};
